// extracted by mini-css-extract-plugin
export default {"balanceItem":"balances-items_balanceItem__rO99X","balanceItemLabel":"balances-items_balanceItemLabel__GVUpb"};